import { useUpgradesStore } from '../../../store/zustand/useUpgradesStore';
import { useCurrencyStore } from '../../../store/zustand/useCurrencyStore';
import { humanNumber } from '@game-libs/exc-libs';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export const InspirationMeterTooltipContent = () => {
  const upgrades = useUpgradesStore((store) => store.upgrades);
  const inspiration = useCurrencyStore((state) => state.inspiration);
  const { t } = useTranslation('tooltip');

  const maxPowerupAmount = 100; // inspiration points
  const maxActiveAmount = upgrades.bard.obnoxiousGuitarist.multiplier; // seconds active
  const maxInspirationMultiplier = upgrades.bard.luteSolo.multiplier;

  let progress = { max: maxPowerupAmount, current: inspiration.amount };

  if (inspiration.remainingActive > 0) {
    progress = { max: maxActiveAmount, current: inspiration.remainingActive };
  }

  return (
    <>
      <div className={styles.tooltipValue}>
        {inspiration.remainingActive <= 0 && (
          <>
            {t('inspiration')}: {humanNumber(progress.current, 2)}/{humanNumber(progress.max, 0)}
          </>
        )}
      </div>
      <div className={styles.tooltipDescription}>{t('inspirationDescription')}</div>
      <div className={styles.tooltipValue}>
        {t('maxInspirationMultiplier')}: x{humanNumber(maxInspirationMultiplier, 1)}
      </div>
    </>
  );
};
